import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  const contactInfo = [{
    icon: MapPin,
    title: 'Dirección',
    details: 'Prolongación Ignacio Aldama 188, San Juan Tepepan, Xochimilco, 16020, CDMX'
  }, {
    icon: Phone,
    title: 'Teléfono',
    details: '55 5436 2239'
  }, {
    icon: Mail,
    title: 'Email',
    details: 'valentinagonzalez761@gmail.com'
  }, {
    icon: Clock,
    title: 'Horario',
    details: 'Lunes a Sábado - 10:00 AM a 7:00 PM'
  }];
  return <section id="ubicacion" className="py-24 bg-white" data-id="element-31">
      <div className="container mx-auto px-6" data-id="element-32">
        <div className="text-center mb-16" data-id="element-33">
          <h2 className="text-4xl md:text-5xl font-heading text-mimate-text mb-4" data-id="element-34">
            Visítanos en el corazón de Xochimilco.
          </h2>
          <div className="w-24 h-1 bg-mimate-primary mx-auto rounded-full" data-id="element-35"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-36">
          {contactInfo.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="flex flex-col items-center text-center p-6 rounded-2xl bg-mimate-bg/50 hover:bg-mimate-bg transition-colors" data-id="element-37">
                <div className="w-16 h-16 bg-mimate-primary/10 rounded-full flex items-center justify-center mb-6 text-mimate-primary" data-id="element-38">
                  <Icon size={28} data-id="element-39" />
                </div>
                <h3 className="font-bold text-mimate-text mb-2 text-lg" data-id="element-40">
                  {item.title}
                </h3>
                <p className="text-mimate-text/70" data-id="element-41">{item.details}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}